"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
const navLinks = [{
  title: "The Experience",
  href: "/ExperiencePage"
}, {
  title: "Global Gatherings",
  href: "/GlobalGatheringsPage"
}, {
  title: "Shop",
  href: "/ShopPage"
}, {
  title: "Glamour Kitty",
  href: "/glamour-kitty"
}];
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="the-opening-portal" className={`fixed top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/90 border-b border-[#a855f7] backdrop-blur-xl py-3" : "bg-transparent py-6"}`} style={isScrolled ? {
    animation: 'borderRotate 3s linear infinite'
  } : {}}>
      <div className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex-shrink-0">
          <Link to="/" className="block">
            <WvcLogo className="h-8 w-auto" />
          </Link>
        </div>

        <div className="flex items-center space-x-6">
          <Link to="http://yogadinners.com/glamour-kitty" newTab className="inline-flex items-center justify-center bg-black/20 backdrop-blur-sm text-[#d946ef] border border-[#a855f7] hover:shadow-[0_0_20px_rgba(168,85,247,0.4)] transition-all tracking-widest uppercase text-xs px-8 h-8 rounded-lg" style={{
          animation: 'borderRotate 3s linear infinite'
        }}>new music</Link>
        </div>
      </div>
    </header>;
}